



























































































































































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import CustomerShowContainer from '@/context/customer/container/CustomerShowContainer.vue';
import FacilityShowContainer from '@/context/facility/containers/FacilityShowContainer.vue';
import DataLoggerShowContainer from '@/context/data_logger/containers/DataLoggerShowContainer.vue';
import MeterShowContainer from '@/context/meter/containers/MeterShowContainer.vue';
import SensorShowContainer from '@/context/sensor/containers/SensorShowContainer.vue';
import CustomExpansionPanel from '@/general/component/expansion-panel/CustomExpansionPanel.vue';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import { notNullOrUndefined, notNullOrUndefinedOrBlank } from '@/utility/functions';
import { ConfirmationDialogType, Nullable, UrlQuery } from '@/general/custom-types/CustomTypes';
import { AxiosResponse } from 'axios';
import { facilityApi } from '@/context/facility/api/FacilityApi';
import { DataLoggerDashboardModel } from '@/context/data_logger/model/DataLoggerDashboardModel';
import { meterRouter } from '@/context/meter/router/MeterRouter';
import TooltipIcon from '@/general/component/tooltip-icon/TooltipIcon.vue';
import { dataLoggerRouter } from '@/context/data_logger/router/DataLoggerRouter';
import Router from '@/common/router/Router';
import { sensorRouter } from '@/context/sensor/router/SensorRouter';
import ConfirmationDialog from '@/general/component/ConfirmationDialog.vue';
import { Api } from '@/common/api/Api';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';
import { meterApi } from '@/context/meter/api/MeterApi';
import { sensorApi } from '@/context/sensor/api/SensorApi';
import ProgressSpinner from '@/general/component/spinner/ProgressSpinner.vue';
import { DashboardContext } from '@/context/facility/model/DashboardContext';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import { facilityRouter } from '@/context/facility/router/FacilityRouter';
import { customerRouter } from '@/context/customer/router/CustomerRouter';
import CustomerRoutes from '@/context/customer/router/CustomerRoutes';
import DataLoggerRoutes from '@/context/data_logger/router/DataLoggerRoutes';
import MeterRoutes from '@/context/meter/router/MeterRoutes';
import SensorRoutes from '@/context/sensor/router/SensorRoutes';
import ColoredBooleanField from "@/general/component/ColoredBooleanField.vue";

@Component({
  components: {
    ColoredBooleanField,
    FacilityAutocomplete,
    ProgressSpinner,
    ConfirmationDialog,
    TooltipIcon,
    CustomerAutocomplete,
    CustomExpansionPanel,
    SensorShowContainer,
    MeterShowContainer,
    DataLoggerShowContainer,
    FacilityShowContainer,
    CustomerShowContainer
  }
})
export default class Dashboard extends Vue {
  @Ref("confirmationDialog") confirmationDialog!: ConfirmationDialogType;
  context: DashboardContext = new DashboardContext();
  sensorHeaders = [
    {
      text: "Id / Numer sensora",
      value: "id",
      align: "left",
      sortable: true
    },
    {
      text: "Ostatni pomiar",
      value: "lastMeasurement",
      align: "left",
      sortable: true
    },
    {
      text: "Numer rejestru",
      value: "registerNumber",
      align: "left",
      sortable: true
    },
    {
      text: "Obis",
      value: "obisNumber",
      align: "left",
      sortable: true
    },
    {
      text: "Aktywny",
      value: "active",
      align: "left",
      sortable: true
    },
    {
      text: "Wirtualny",
      value: "virtual",
      align: "left",
      sortable: true
    },
    {
      text: "Kalkulacja wirtualna",
      value: "virtualCalculation",
      align: "left",
      sortable: true
    },
    {
      text: "Biznesowy (Business)",
      value: "business",
      align: "left",
      sortable: true
    },
    {
      text: "Rozliczeniowy (Billing)",
      value: "billing",
      align: "left",
      sortable: true
    },
    {
      text: "Report",
      value: "report",
      align: "left",
      sortable: true
    },
    {
      text: "Tableau",
      value: "tableau",
      align: "left",
      sortable: true
    },

    {
      text: "Agregowany",
      value: "aggregatable",
      align: "left",
      sortable: true
    },
    {
      text: "Agregacja 15 min",
      value: "quarterlyAggregated",
      align: "left",
      sortable: true
    },
    {
      text: "Agregacja 1h",
      value: "hourlyAggregated",
      align: "left",
      sortable: true
    },
    {
      text: "Agregacja 1d",
      value: "dailyAggregated",
      align: "left",
      sortable: true
    },
    {
      text: "Agregacja 1m",
      value: "monthlyAggregated",
      align: "left",
      sortable: true
    },
    {
      text: "Akcje",
      value: "actions",
      align: "left"
    }
  ];
  meterHeaders = [
    {
      text: "Id",
      value: "id",
      align: "left"
    },
    {
      text: "Numer licznika",
      value: "number",
      align: "left"
    },
    {
      text: "Model licznika",
      value: "model",
      align: "left"
    },
    {
      text: "Lokalizacja",
      value: "location",
      align: "left"
    },
    {
      text: "Opis",
      value: "description",
      align: "left"
    },
    {
      text: "Akcje",
      value: "actions",
      align: "left"
    }
  ];
  dataLoggerHeaders: Array<Record<string, unknown>> = [
    {
      text: "Id",
      value: "id",
      align: "left"
    },
    {
      text: "Identyfikator",
      value: "identifier",
      align: "left"
    },
    {
      text: "Akcje",
      value: "actions",
      align: "left"
    }
  ];
  customerRouter: Router = customerRouter;
  dataLoggerRouter: Router = dataLoggerRouter;
  meterRouter: Router = meterRouter;
  sensorRouter: Router = sensorRouter;
  customerRoutes: CustomerRoutes = new CustomerRoutes();
  dataLoggerRoutes: DataLoggerRoutes = new DataLoggerRoutes();
  meterRoutes: MeterRoutes = new MeterRoutes();
  sensorRoutes: SensorRoutes = new SensorRoutes();
  dataLoggerApi: Api = dataLoggerApi;
  meterApi: Api = meterApi;
  sensorApi: Api = sensorApi;
  facilityRouter: Router = facilityRouter;
  loading: boolean = false;
  loadingContextFromUrl: boolean = false;

  hasModel: boolean = false;

  get facilityQueryParam(): string {
    console.log("client=" + this.context.customer);
    return "client=" + this.context.customer;
  }

  get isCustomer(): boolean {
    return notNullOrUndefined(this.context.customer);
  }

  get isFacility(): boolean {
    return notNullOrUndefined(this.context.facility);
  }

  get isModel(): boolean {
    console.log(this.context);
    return notNullOrUndefined(this.context.model);
  }

  get selectedDataLogger(): Nullable<DataLoggerDashboardModel> {
    return this.context.dataLoggerSelection.length != 0
      ? this.context.dataLoggerSelection[0]
      : null;
  }

  get isSelectedDataLogger(): boolean {
    const condition1: boolean =
      notNullOrUndefined(this?.context?.model?.dataLoggers) &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // ts pulta sie, sie ze moze byc nullem, ale linijke wyzej jest sprawdzenie
      Array.isArray(this.context.model.dataLoggers) &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // ts pulta sie, sie ze moze byc nullem, ale linijke wyzej jest sprawdzenie
      this.context.model.dataLoggers.length != 0;
    const condition2: boolean = notNullOrUndefined(this.selectedDataLogger);
    return condition1 && condition2;
  }

  selectFirstDataLogger(): void {
    if (this.context.model && this.context.model.dataLoggers.length > 0) {
      this.context.dataLoggerSelection = [this.context.model.dataLoggers[0]];
    }
  }

  async fetch(): Promise<void> {
    this.loading = true;
    if (this.context.facility) {
      const query: string = "id=" + this.context.facility;
      const response: AxiosResponse = await facilityApi.findDashboard(query);
      this.context.model = response.data.view;
      console.log(this.context);
      const selectedDataLoggerIds = this.context.dataLoggerSelection.map(i => i.id);
      console.log(selectedDataLoggerIds);
      const dataLoggers = this.context?.model?.dataLoggers?.filter(i =>
        selectedDataLoggerIds.includes(i.id)
      );
      if (dataLoggers != undefined) {
        this.context.dataLoggerSelection = dataLoggers;
      }
      // const meterDevices = this.context.model.dataLoggers.filter(i => selectedDataLoggerIds.includes(i)).filter()
      this.hasModel = true;
      if (!this.loadingContextFromUrl) {
        // this.selectFirstDataLogger();
      }
      this.loadingContextFromUrl = false;
    }
    // this.updateContextToUrl();
    this.loading = false;
  }

  @Watch("context.customer")
  customerWatcherHandle(): void {
    if (!this.loadingContextFromUrl) {
      this.context.facility = null;
    }
    this.saveToLocalStorage();
    // this.updateContextToUrl();
  }

  @Watch("context.facility")
  async facilityWatcherHandle(): Promise<void> {
    await this.fetch();
    this.saveToLocalStorage();
    // this.updateContextToUrl();
  }

  @Watch("context.model")
  modelWatcherHandle(): void {
    this.saveToLocalStorage();
    // this.updateContextToUrl();
  }

  @Watch("context.dataLoggerSelection")
  dataLoggerSelectionWatcherHandle(): void {
    this.saveToLocalStorage();
    // this.updateContextToUrl();
  }

  @Watch("context.expanded")
  expandedWatcherHandle(): void {
    this.saveToLocalStorage();
    // this.updateContextToUrl();
  }

  goToShow(router: Router, id: number): void {
    const route: Record<string, unknown> = router.show(id);
    this.$router.push(route);
  }

  goToUpdate(router: Router, id: number): void {
    const route: Record<string, unknown> = router.update(id);
    this.$router.push(route);
  }

  async deactivateEntity(api: Api, id: number): Promise<void> {
    const confirmation: boolean = await this.confirmationDialog.open(
      "Dezaktywacja",
      "Czy jesteś pewien, że chcesz dezaktywować element?",
      { color: "red" }
    );
    if (confirmation) {
      await api.deactivate(id);
      await this.fetch();
      this.confirmationDialog.close();
    }
  }

  async deleteEntity(api: Api, id: number): Promise<void> {
    const confirmation: boolean = await this.confirmationDialog.open(
      "Usuwanie",
      "Czy jesteś pewien, że chcesz usunąć element?",
      { color: "red" }
    );
    if (confirmation) {
      await api.delete(id);
      await this.fetch();
      this.confirmationDialog.close();
    }
  }

  loadContextFromUrl(): void {
    const contextQuery: string | (string | null)[] = this.$route?.query?.context;
    //TODO: znalezc lepszy sposob na to zapis/odczyt z urla, bo json to slaba opcja albo to chociaz kodowac
    const contextUrl: string = typeof contextQuery === "string" ? contextQuery.toString() : "";
    if (notNullOrUndefinedOrBlank(contextUrl)) {
      const context: DashboardContext = JSON.parse(contextUrl);
      Object.assign(this.context, context);
    }
  }

  updateContextToUrl(): void {
    const context: string = encodeURIComponent(JSON.stringify(this.context));
    let query: UrlQuery = this.loadRouteQuery();
    query.context = context;
    this.updateUrlQuery(query);
    this.saveToLocalStorage();
  }

  updateUrlQuery(query: UrlQuery): void {
    // TODO: Niestety trzeba try catchowac. Mozna to ominac zmieniajac mode routera na history, a linijke this.router.replace zamieniajac na window.history.pushstate
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.$router.replace({ query: query }).catch(() => {});
  }

  loadRouteQuery(): UrlQuery {
    let query: UrlQuery = Object.assign({}, this.$route.query);
    return query;
  }

  async mounted(): Promise<void> {
    const contextQuery: string | (string | null)[] = this.$route?.query?.context;
    if (contextQuery) {
      this.loadingContextFromUrl = true;
    }
    // this.loadContextFromUrl();
    this.loadFromLocalStorage();
    // await this.fetch();
  }

  private loadFromLocalStorage() {
    const maybeContext = window.localStorage.getItem("dashboard-context");
    if (maybeContext) {
      this.loadingContextFromUrl = true;
      this.context = JSON.parse(maybeContext);
    }
  }

  private clearLocalStorage() {
    this.context = new DashboardContext();
    this.saveToLocalStorage();
  }
  private saveToLocalStorage() {
    window.localStorage.setItem("dashboard-context", JSON.stringify(this.context));
  }
}
